import { Navigate, useLocation } from 'react-router-dom';
import { isAdminLoggedIn } from '../lib/adminAuth';

export default function RequireAdmin({ children }) {
  const location = useLocation();
  if (!isAdminLoggedIn()) return <Navigate to="/admin/login" state={{ from: location }} replace />;
  return children;
}
